import React, { useContext, useEffect, useRef, useState } from 'react';
import '../../../assests/css/admin/CourseSemesterManagement.css';
import Adminmasterlayout from '../../../layouts/Adminmasterlayout/Adminmasterlayout';
import { AppContext } from '../../../context/Appcontext';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Spinner } from 'react-bootstrap';



const CourseSemester = () => {
  const { baseUrl } = useContext(AppContext);
  const [programmes, setProgrammes] = useState([]);
  const [courses, setCourses] = useState([]);
  const [code, setCode] = useState('');
  const [semester, setSemester] = useState("1");
  const [programme, setProgramme] = useState("");
  const [name, setName] = useState('');
  const [credits, setCredits] = useState('');
  const [status, setStatus] = useState('Active');
  // const [image, setImage] = useState("");
  // const [imagePreview, setImagePreview] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [uploading, setUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [progIdForUpdate, setProgIdForUpdate] = useState(null);

  const fileInputRef = useRef(null);
  const formRef = useRef(null);

  /* IMAGE CHANGE */
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage(file);
  //     setImagePreview(URL.createObjectURL(file));
  //   }
  // };

  /* SEARCH FILTER */
  const filteredCourses = courses.filter(course =>
    (course.code || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (course.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (course.programme || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const resetForm = () => {
    setName('');
    setCode('');
    setStatus('Active');
    setCredits('');
    setProgramme('');
    setSemester("1");
    setProgIdForUpdate(null);
  };
  /* UPLOAD COURSE */
  const uploadCourses = () => {
    console.log({
      code,
      name,
      credits,
      programme,
      semester,
      status
    });

    const formData = new FormData();
    formData.append("code", code);
    formData.append("name", name);
    formData.append("credits", credits);
    formData.append("ngprogramme_id", programme);
    formData.append("status", status);
    formData.append("semester", semester);
    // if (image) {
    // formData.append("image", image);
    // }

    setUploading(true);

    axios.post(`${baseUrl}/Admin/Courses/uploadCourses`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => {
      console.log(response.data);
      setCode('');
      setName('');
      setCredits('');
      setProgramme('');
      setSemester("1");
      setStatus('Active');
      setUploading(false);
      // setImage("");
      // setImagePreview(null);
      viewAllCourses();
    }).catch((error) => {
      console.log(error);
      setUploading(false);
    })
  };


 const updateCourse = () => {
  setUploading(true);

  const formData = new FormData();

  formData.append("course_id", progIdForUpdate);
  formData.append("code", code);
  formData.append("name", name);
  formData.append("credits", credits);
  formData.append("ngprogramme_id", programme);
  formData.append("status", status);
  formData.append("semester", semester);

  axios
    .post(`${baseUrl}/Admin/Courses/updateCourses`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      console.log(response.data);

      viewAllCourses();
      resetForm();
      setShowModal(false);
      setUploading(false);
    })
    .catch((error) => {
      console.error(error);
      setUploading(false);
    });
};

  const handleSubmit = () => {
    console.log("Semester =", semester);

    if (progIdForUpdate === null) {
      uploadCourses();
    } else {
      updateCourse();
    }
  };
  /* VIEW COURSES */
  const viewAllCourses = () => {
    axios.get(`${baseUrl}/Admin/Courses/viewAllCourses`)
      .then((response) => {
        console.log(response.data)
        setCourses(response.data.courses);
      }).catch((error) => {
        console.log(error);
      });
  };


  const handleOpenEditModal = (course) => {
    setProgIdForUpdate(course.id);

    setName(course.name);

    setCode(course.code);
    setCredits(course.credits);
  setProgramme(course.ngprogramme_id);
    setStatus(course.status);
    setSemester(course.semester);
    setShowModal(true);
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const viewAllProgramme = () => {
    axios
      .get(`${baseUrl}/admin/programme/viewAllProgramme`)
      .then((response) => {
        console.log(response.data);
        setProgrammes(response.data.programmes);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllCourses();
    viewAllProgramme();
  }, []);

  return (
    <Adminmasterlayout>
      <div className="csm">
        <div className="csm__container">

          {/* Header */}
          <header className="csm__header">
            <div className="csm__header-content">
              <h1 className="csm__header-title">Course Management</h1>
              <p className="csm__header-subtitle">Manage and organize your academic courses efficiently</p>
            </div>
          </header>

          {/* Stats Cards */}
          <div className="csm__stats">
            <div className="csm__stats-card">
              <div className="csm__stats-icon csm__stats-icon--blue"></div>
              <div className="csm__stats-content">
                <p className="csm__stats-label">Total Courses</p>
                <p className="csm__stats-value">{courses.length}</p>
              </div>
            </div>
            <div className="csm__stats-card">
              <div className="csm__stats-icon csm__stats-icon--green"></div>
              <div className="csm__stats-content">
                <p className="csm__stats-label">Active Courses</p>
                <p className="csm__stats-value">{courses.filter(c => c.status === 'Active').length}</p>
              </div>
            </div>
            <div className="csm__stats-card">
              <div className="csm__stats-icon csm__stats-icon--orange"></div>
              <div className="csm__stats-content">
                <p className="csm__stats-label">Inactive Courses</p>
                <p className="csm__stats-value">{courses.filter(c => c.status === 'Inactive').length}</p>
              </div>
            </div>
          </div>

          {/* Add Course Form */}
          <section className="csm__form-section" ref={formRef}>
            <h2 className="csm__section-title">Add New Course</h2>
            <div className="csm__form-grid">

              <div className="csm__form-group">
                <label className="csm__form-label">Course Code</label>
                <input
                  type="text"
                  className="csm__form-input"
                  placeholder="e.g., CS101"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>

              <div className="csm__form-group">
                <label className="csm__form-label">Course Name</label>
                <input
                  type="text"
                  className="csm__form-input"
                  placeholder="Enter course name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="csm__form-group">
                <label className="csm__form-label">Credits</label>
                <input
                  type="number"
                  className="csm__form-input"
                  placeholder="Credit hours"
                  value={credits}
                  onChange={(e) => setCredits(e.target.value)}
                  min="1"
                  max="6"
                />
              </div>
              <div className="csm__form-group">
                <label className="csm__form-label">Semester</label>
                <select
                  type="text"
                  className="csm__form-input"
                  placeholder="Enter semester"
                  value={semester}
                  onChange={(e) => setSemester(e.target.value)}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>
              </div>

              {/* <div className="prog-form__group">
                <label className="prog-form__label">Semester</label>
                <select
                  value={semester}
                  onChange={(e) => setSemester(e.target.valu`e)}
                  className="csm-form__select"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>
              </div> */}



              <div className="csm__form-group">
                <label className="csm__form-label">Programme</label>
                <select



                  type="text"
                  className="csm__form-input"
                  placeholder="Enter programme"
                  value={programme}
                  onChange={(e) => setProgramme(e.target.value)}
                >
                  <option value="0">SELECT PROGRAMMEs</option>
                  {programmes.map((prog) => {
                    return <option value={prog.id}>{prog.progName}</option>
                  })}
                </select>
              </div>




              <div className="csm__form-group">
                <label className="csm__form-label">Status</label>
                <select
                  className="csm__form-input"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              {/* Image Upload Field */}
              <div className="csm__form-group">
                {/* <label className="csm__form-label">Course Image</label> */}

                {/* Hidden file input — triggered via ref */}
                {/* <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageChange}
                /> */}

                {/* Clickable preview box */}
                {/* <div
                  className="csm__image-upload-box"
                  onClick={() => fileInputRef.current.click()}
                  title="Click to upload course image"
                > */}
                {/* {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Course Preview"
                      className="csm__image-preview"
                    />
                  ) : (
                    <div className="csm__image-placeholder">
                      <span className="csm__image-placeholder-icon"></span>
                      <span className="csm__image-placeholder-text">Click to upload</span>
                    </div>
                  )}
                </div> */}

                {/* {image && (
                  <p className="csm__image-name">{image.name}</p>
                )} */}
              </div>

            </div>

            {/* UPLOAD COURSE BUTTON — fully wired, shows loading state */}
            {/* <button
              className={`csm__btn csm__btn--primary ${uploading ? 'csm__btn--loading' : ''}`}
              onClick={handleSubmit}
              disabled={uploading}
            >
              {uploading ? 'Uploading...' : 'Upload Course'}
            </button> */}
            {uploading ? (
              <Spinner size="lg" />
            ) : (
              <button
                className={`csm__btn csm__btn--primary`}
                onClick={handleSubmit}
              >
                {progIdForUpdate === null ? 'Upload Course' : 'Update Course'}
              </button>
            )}
            {/* <button
                  className="csm-btn csm-btn--primary"
                  onClick={handleSubmit}
                >
                  {progIdForUpdate === null ? 'Upload Course' : 'Update Course'}
                </button> */}
            {/* <button
                  className="dept-btn dept-btn--primary"
                  onClick={handleSubmit}
                >
                  {progIdForUpdate === null ? 'Upload Course' : 'Update Couse'}
                </button> */}

          </section>

          {/* Search Bar */}
          <div className="csm__search">
            <input
              type="text"
              className="csm__search-input"
              placeholder="Search by course code, name, or programme..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Courses Table */}
          <section className="csm__table-section">
            <h2 className="csm__section-title">Courses List</h2>
            <div className="csm__table-container">
              <table className="csm__table">
                <thead className="csm__table-head">
                  <tr className="csm__table-row">
                    {/* <th className="csm__table-header">Image</th> */}
                    <th className="csm__table-header">Course Code</th>
                    <th className="csm__table-header">Course Name</th>
                    <th className="csm__table-header">Credits</th>
                    <th className="csm__table-header">Programme</th>
                    <th className="csm__table-header">Semester</th>
                    <th className="csm__table-header">Status</th>

                    <th className="csm__table-header">Actions</th>
                  </tr>
                </thead>
                <tbody className="csm__table-body">
                  {filteredCourses.map(course => (
                    <tr key={course.id} className="csm__table-row">

                      {/* <td className="csm__table-cell" data-label="Image">
                        {course.image ? (
                          <img
                            src={`${baseUrl}/uploads/${course.image}`}
                            alt={course.image}
                            style={{
                              width: '48px',
                              height: '48px',
                              objectFit: 'cover',
                              borderRadius: '8px',
                              border: '1px solid #e2e8f0'
                            }}
                          />
                        ) : (
                          <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '8px',
                            backgroundColor: '#edf2f7',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '20px'
                          }}>
                            
                          </div>
                        )}
                      </td> */}

                      <td className="csm__table-cell" data-label="Course Code">
                        <span className="csm__course-code">{course.code}</span>
                      </td>

                      <td className="csm__table-cell csm__table-cell--bold" data-label="Course Name">
                        {course.name}
                      </td>

                      <td className="csm__table-cell" data-label="Credits">
                        <span className="csm__credits-badge">{course.credits} hrs</span>
                      </td>

                      <td className="csm__table-cell" data-label="Programme">
                        {course.ngprogramme?.progName}
                      </td>

                      <td className="csm__table-cell" data-label="Semester">
                        {course.semester}
                      </td>

                      <td className="csm__table-cell" data-label="Status">
                        <span className={`csm__status-badge csm__status-badge--${(course.status || "").toLowerCase()}`}>
                          {course.status}
                        </span>
                      </td>

                      {/* ENABLE / DISABLE BUTTON — fully wired with toggleCourseStatus */}
                      <td className="csm__table-cell" data-label="Actions">
                        <div className="csm__action-buttons">

                          <button
                            className="dept-toggle-btn dept-toggle-btn--edit"
                            title="Edit Department"
                            onClick={() => handleOpenEditModal(course)}
                           
                          >
                            Edit
                          </button>

                        </div>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>

              {filteredCourses.length === 0 && (
                <div className="csm__empty-state">
                  <span></span>
                  <p>No courses found.</p>
                </div>
              )}

            </div>
          </section>

        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default CourseSemester;